import { useQuery } from 'react-query';

export enum AirportMarketFilter {
  ALL = 'ALL',
  ORIGIN = 'ORIGIN',
  DESTINATION = 'DESTINATION',
  NONE = 'NONE'
}

export type Airport = {
  label: string;
  value: string;
  country?: { isoCode: string; name: string };
  locationId?: string;
  zoneId?: string;
  city?: $TSFixMe;
  extraInfo?: $TSFixMe;
};

type AirportOptions = {
  airportType?: 'ORIGIN' | 'DESTINATION';
  selectedOrigin?: string;
  selectedDestination?: string;
  filterFields: AirportMarketFilter;
  avoidCall?: boolean;
  sameCall?: boolean;
  panel?: number;
};

export type FetchAirports = (options: AirportOptions) => Promise<Airport[]>;

export function useAirports(fetchAirports: FetchAirports, options: AirportOptions) {
  let key =
    options.airportType === 'ORIGIN'
      ? `origins-${options.selectedDestination ?? ''}-${options.panel}`
      : `destinations-${options.selectedOrigin ?? ''}-${options.panel}`;

  if (options.airportType === 'ORIGIN' && options.sameCall) {
    key = `origins-${options.panel}`;
  }

  return useQuery(key, () => (options.avoidCall ? [] : fetchAirports(options)), {
    refetchOnWindowFocus: false,
    staleTime: 86400000
  });
}
